import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { site } from "@/data/site";
import Footer from "@/sections/Footer";

const Shell = ({ title, testid, children }) => (
    <main data-testid={testid} className="pt-28 sm:pt-36">
        <div className="mx-auto max-w-[900px] px-5 pb-24 sm:px-10">
            <Link
                to="/"
                data-testid={`${testid}-back-link`}
                data-cursor="link"
                className="mb-10 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#A1A1AA] transition-colors duration-300 hover:text-[#E63946]"
            >
                <ArrowLeft size={14} /> Zurück zur Startseite
            </Link>
            <h1 className="mb-12 font-display text-4xl font-bold uppercase tracking-tight text-[#F4F4F0] sm:text-6xl">
                {title}
            </h1>
            <div className="space-y-8 text-sm leading-relaxed text-[#A1A1AA] sm:text-base">{children}</div>
        </div>
        <Footer />
    </main>
);

const H = ({ children }) => (
    <h2 className="font-display text-lg font-bold uppercase tracking-tight text-[#F4F4F0]">{children}</h2>
);

export const Impressum = () => (
    <Shell title="Impressum" testid="impressum-page">
        <p className="rounded border border-[#E63946]/40 bg-[#E63946]/10 p-4 text-[#F4F4F0]">
            Hinweis: Dies ist ein Muster-Impressum. Bitte ersetze die Angaben durch deine tatsächlichen Daten (§ 5 TMG/DDG).
        </p>
        <section>
            <H>Angaben gemäß § 5 DDG</H>
            <p className="mt-3">
                {site.owner}
                <br />
                {site.studioName}
                <br />
                {site.address}
            </p>
        </section>
        <section>
            <H>Kontakt</H>
            <p className="mt-3">
                Telefon: {site.phone}
                <br />
                E-Mail: {site.email}
            </p>
        </section>
        <section>
            <H>Umsatzsteuer-ID</H>
            <p className="mt-3">Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: [eintragen]</p>
        </section>
        <section>
            <H>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H>
            <p className="mt-3">
                {site.owner}, Anschrift wie oben
            </p>
        </section>
    </Shell>
);

const Li = ({ children }) => (
    <li className="flex gap-3">
        <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-[#E63946]" />
        <span>{children}</span>
    </li>
);

export const Datenschutz = () => (
    <Shell title="Datenschutz" testid="datenschutz-page">
        <section>
            <H>1. Verantwortlicher</H>
            <p className="mt-3">
                Verantwortlich für die Datenverarbeitung auf dieser Website ist:
                <br />
                BVISION Designer Studio
                <br />
                +49 170 8045370
                <br />
                bvision.designer@hotmail.com
            </p>
        </section>
        <section>
            <H>2. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung</H>
            <p className="mb-2 mt-3 font-semibold text-[#F4F4F0]">a) Beim Besuch der Website</p>
            <p>
                Beim Aufrufen dieser Website werden automatisch Informationen durch den Browser deines Endgeräts an den
                Server dieser Website gesendet. Diese Informationen werden temporär in einem sogenannten Logfile
                gespeichert. Folgende Informationen werden dabei ohne dein Zutun erfasst und bis zur automatisierten
                Löschung gespeichert:
            </p>
            <ul className="mt-3 space-y-2">
                <Li>IP-Adresse des anfragenden Rechners</Li>
                <Li>Datum und Uhrzeit des Zugriffs</Li>
                <Li>Name und URL der abgerufenen Datei</Li>
                <Li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</Li>
                <Li>verwendeter Browser und ggf. Betriebssystem deines Rechners</Li>
                <Li>Name deines Access-Providers</Li>
            </ul>
            <p className="mt-3">Die genannten Daten werden zu folgenden Zwecken verarbeitet:</p>
            <ul className="mt-3 space-y-2">
                <Li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</Li>
                <Li>Gewährleistung einer komfortablen Nutzung unserer Website</Li>
                <Li>Auswertung der Systemsicherheit und -stabilität</Li>
                <Li>zu weiteren administrativen Zwecken</Li>
            </ul>
            <p className="mb-2 mt-6 font-semibold text-[#F4F4F0]">b) Kontaktformular</p>
            <p>
                Wenn du uns per Kontaktformular Anfragen zukommen lässt, werden deine Angaben aus dem Formular
                inklusive der von dir dort angegebenen Kontaktdaten gespeichert, um deine Anfrage zu bearbeiten und für
                den Fall von Anschlussfragen. Diese Daten geben wir nicht ohne deine Einwilligung weiter.
            </p>
        </section>
        <section>
            <H>3. Weitergabe von Daten</H>
            <p className="mt-3">
                Eine Übermittlung deiner persönlichen Daten an Dritte zu anderen als den nachfolgend aufgeführten
                Zwecken findet nicht statt. Wir geben deine persönlichen Daten nur weiter, wenn:
            </p>
            <ul className="mt-3 space-y-2">
                <Li>du deine ausdrückliche Einwilligung dazu erteilt hast (Art. 6 Abs. 1 lit. a DSGVO)</Li>
                <Li>die Verarbeitung zur Erfüllung eines Vertrags mit dir erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO)</Li>
                <Li>eine gesetzliche Verpflichtung zur Weitergabe besteht (Art. 6 Abs. 1 lit. c DSGVO)</Li>
                <Li>
                    die Verarbeitung zur Wahrung berechtigter Interessen erforderlich ist (Art. 6 Abs. 1 lit. f DSGVO)
                    und kein Grund zur Annahme besteht, dass du ein überwiegendes schutzwürdiges Interesse an der
                    Nichtweitergabe deiner Daten hast.
                </Li>
            </ul>
        </section>
        <section>
            <H>4. Social Media Plugins (Instagram und TikTok)</H>
            <p className="mt-3">
                Auf unserer Website können Social Media Plugins von Instagram (Meta Platforms, 1601 Willow Road, Menlo
                Park, CA 94025, USA) und TikTok (TikTok Technology Limited, 10 Earlsfort Terrace, Dublin, D02 T380,
                Ireland) integriert sein.
            </p>
            <p className="mt-3">
                Wenn du eine Seite besuchst, auf der ein solches Plugin eingebunden ist, wird eine direkte Verbindung
                zwischen deinem Browser und dem Server des jeweiligen Anbieters hergestellt. Dabei erhält der Anbieter
                die Information, dass du mit deiner IP-Adresse unsere Seite besucht hast. Wenn du gleichzeitig in
                deinem Benutzerkonto des jeweiligen Netzwerks eingeloggt bist, kann der Anbieter den Besuch unserer
                Website deinem Benutzerkonto zuordnen.
            </p>
            <p className="mt-3">
                Wir weisen darauf hin, dass wir keine Kenntnis vom genauen Inhalt der übermittelten Daten sowie deren
                Nutzung durch die Anbieter haben. Weitere Informationen findest du in den Datenschutzhinweisen der
                jeweiligen Anbieter:
            </p>
            <ul className="mt-3 space-y-2">
                <Li>
                    Instagram:{" "}
                    <a
                        href="https://privacycenter.instagram.com/policy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-cursor="link"
                        className="text-[#F4F4F0] underline underline-offset-4 hover:text-[#E63946]"
                    >
                        privacycenter.instagram.com/policy
                    </a>
                </Li>
                <Li>
                    TikTok:{" "}
                    <a
                        href="https://www.tiktok.com/legal/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-cursor="link"
                        className="text-[#F4F4F0] underline underline-offset-4 hover:text-[#E63946]"
                    >
                        tiktok.com/legal/privacy-policy
                    </a>
                </Li>
            </ul>
        </section>
        <section>
            <H>5. Cookies</H>
            <p className="mt-3">
                Diese Website verwendet Cookies. Cookies sind kleine Textdateien, die auf deinem Endgerät gespeichert
                werden. Sie richten keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, das Angebot
                dieser Website nutzerfreundlicher, effektiver und sicherer zu machen.
            </p>
            <p className="mt-3">
                Du kannst deinen Browser so einstellen, dass du über das Setzen von Cookies informiert wirst und
                Cookies nur im Einzelfall erlaubst, die Annahme von Cookies für bestimmte Fälle oder generell
                ausschließt sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivierst.
            </p>
        </section>
        <section>
            <H>6. Betroffenenrechte</H>
            <p className="mt-3">Du hast das Recht:</p>
            <ul className="mt-3 space-y-2">
                <Li>gemäß Art. 15 DSGVO Auskunft über deine von uns verarbeiteten personenbezogenen Daten zu verlangen</Li>
                <Li>
                    gemäß Art. 16 DSGVO die Berichtigung unrichtiger oder Vervollständigung deiner gespeicherten
                    personenbezogenen Daten zu verlangen
                </Li>
                <Li>
                    gemäß Art. 17 DSGVO die Löschung deiner gespeicherten personenbezogenen Daten zu verlangen, soweit
                    keine gesetzlichen Aufbewahrungspflichten entgegenstehen
                </Li>
                <Li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung deiner personenbezogenen Daten zu verlangen</Li>
                <Li>gemäß Art. 20 DSGVO die Übertragung deiner personenbezogenen Daten zu verlangen</Li>
                <Li>gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung einzulegen</Li>
                <Li>gemäß Art. 77 DSGVO sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.</Li>
            </ul>
        </section>
        <section>
            <H>7. Widerrufsrecht</H>
            <p className="mt-3">
                Sofern du eine Einwilligung zur Datenverarbeitung erteilt hast, kannst du diese jederzeit widerrufen.
                Ein solcher Widerruf wirkt nur für die Zukunft.
            </p>
        </section>
        <section>
            <H>8. Datensicherheit</H>
            <p className="mt-3">
                Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) zur
                sicheren Datenübertragung.
            </p>
        </section>
        <section>
            <H>9. Aktualität und Änderung dieser Datenschutzerklärung</H>
            <p className="mt-3">
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand September 2026. Durch die
                Weiterentwicklung dieser Website oder aufgrund gesetzlicher Änderungen kann es notwendig werden, diese
                Datenschutzerklärung zu ändern. Die jeweils aktuelle Version findest du jederzeit auf dieser Website.
            </p>
        </section>
        <section>
            <H>10. Urheberrecht und Nutzungshinweise</H>
            <p className="mt-3">
                Alle auf dieser Website veröffentlichten Inhalte (Texte, Bilder, Fotos, Grafiken, Videos etc.) sind
                urheberrechtlich geschützt und Eigentum von BVISION Designer Studio (Berkay Budak) oder den jeweils
                genannten Rechteinhabern.
            </p>
            <p className="mt-3">
                Eine Vervielfältigung, Bearbeitung, Verbreitung, öffentliche Wiedergabe oder sonstige Verwendung der
                Inhalte außerhalb der engen Grenzen des Urheberrechtsgesetzes ist ohne ausdrückliche schriftliche
                Zustimmung des Rechteinhabers unzulässig. Downloads und Kopien dieser Website sind nur für den
                privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p className="mt-3">
                Eine gewerbliche Nutzung der Inhalte (z. B. Verkauf, Veröffentlichung, Bearbeitung, Einbindung auf
                anderen Websites) ist ausdrücklich untersagt.
            </p>
            <p className="mt-3">
                Wenn du glaubst, dass auf dieser Website Inhalte veröffentlicht sind, die deine Rechte verletzen,
                kontaktiere uns bitte umgehend, damit wir den Sachverhalt prüfen und gegebenenfalls entfernen können.
            </p>
        </section>
    </Shell>
);
